<template>
  <list-form @submit.prevent="doSearch" @reset.prevent="doReset">
    <template #search-form>
      <div class="row">
        <vuex-text-search-item class="col" label="発行依頼ID" bind="id" />
        <vuex-select-search-item class="col" label="ステータス" bind="status" :options="$constant.ISSUANCE_REQUEST_STATUS_LIST" value-key="code" />
      </div>
      <div class="row">
        <vuex-text-search-item class="col" label="依頼物件名・棟名" bind="building_name" />
        <vuex-text-search-item class="col" label="依頼物件名・棟名（カナ）" bind="building_name_kana" />
      </div>
      <div class="row">
        <vuex-date-range-search-item class="col" label="依頼日" bind-from="request_at_from" bind-to="request_at_to" />
        <vuex-date-range-search-item class="col" label="振込通知日" bind-from="transfer_notification_date_from" bind-to="transfer_notification_date_to" />
      </div>
      <div class="row">
        <vuex-date-range-search-item class="col" label="振込明細書確認日" bind-from="transfer_confirm_date_from" bind-to="transfer_confirm_date_to" />
        <vuex-date-range-search-item class="col" label="発行日" bind-from="issued_at_from" bind-to="issued_at_to" />
      </div>
      <div class="row">
        <vuex-date-range-search-item class="col" label="ダウンロード期限日" bind-from="expire_datetime_from" bind-to="expire_datetime_to" />
         <div class="form-group row col" />
      </div>
    </template>
    <template #table>
      <div v-if="issuance_requests.length">
        <plain-table :headers="tableHeaders" :data="tableData" :pagination="paginationStatus" :sort="sortStatus"
                     @select="toDetail" @change-page="doChangePage" @sort="doSort"
        />
      </div>
      <danger-alert v-else message="表示する発行依頼がありませんでした。" />
    </template>
  </list-form>
</template>

<script>
import {mapState, mapMutations} from 'vuex';
import AddonLoadPageEvent from '@/mixin/AddonLoadPageEvent'
import ListForm from '@/views/templates/forms/ListForm'
import VuexTextSearchItem from '@/views/molecules/searchItems/VuexTextSearchItem'
import VuexSelectSearchItem from '@/views/molecules/searchItems/VuexSelectSearchItem'
import VuexDateRangeSearchItem from '@/views/molecules/searchItems/VuexDateRangeSearchItem'
import PlainTable from '@/views/molecules/PlainTable'
import DangerAlert from '@/views/atoms/alerts/DangerAlert'

export default {
  name: 'IssuanceRequestOwnList',
  components: {
    ListForm,
    VuexTextSearchItem,
    VuexSelectSearchItem,
    VuexDateRangeSearchItem,
    PlainTable,
    DangerAlert,
  },
  mixins: [AddonLoadPageEvent],
  provide: {
    bindModule: 'issuance_request_own_index'
  },
  inject: [
    '$constant',
  ],
  data() {
    return {
      tableHeaders: [
        {label: 'ID', column: 'id'},
        {label: 'ステータス', column: 'status'},
        {label: '依頼物件名・棟名', column: 'building_name'},
        {label: '住戸番号', column: 'building_house_number'},
        {label: '依頼物件住所', column: 'building_address'},
        {label: '依頼者', column: 'request_by'},
        {label: '発行書類', column: 'issue_document'},
        {label: '依頼日時', column: 'request_at'},
        {label: '振込通知日', column: 'transfer_notification_date'},
        {label: '振込明細書確認日', column: 'transfer_confirm_date'},
        {label: '発行日', column: 'issued_at'},
        {label: 'ダウンロード期限日', column: 'expire_datetime'},
      ],
    }
  },
  computed: {
    ...mapState('issuance_request_own_index', [
      'issuance_requests',
      'paginationStatus',
      'sortStatus',
    ]),
    tableData() {
      return this.issuance_requests.map(issuance_request => ({
        id: issuance_request.id,
        status: issuance_request.status,
        building_name: issuance_request.building_name,
        building_house_number: issuance_request.building_house_number,
        building_address: issuance_request.building_address,
        request_by: issuance_request.request_by,
        issue_document: issuance_request.issue_documents[0].name + ((1 < issuance_request.issue_documents.length) ? ' 等' : ''),
        request_at: issuance_request.request_at,
        transfer_notification_date: issuance_request.transfer_notification_date,
        transfer_confirm_date: issuance_request.transfer_confirm_date,
        issued_at: issuance_request.issued_at,
        expire_datetime: issuance_request.expire_datetime,
      }))
    },
  },
  methods: {
    ...mapMutations('issuance_request_own_index', [
      'setSortColumn',
      'setCurrentPage',
      'setPerPage',
    ]),
    loadPage() {
      if (this.paginationStatus.per_page === null) {
        this.setPerPage({value: this.$constant.PAGINATION.PER_PAGE});
      }
      return this.$store.dispatch('issuance_request_own_index/load').catch((reason) => this.$root.failApi(reason));
    },
    doSearch() {
      this.setCurrentPage({value: 1});
      this.loadPage();
    },
    doReset() {
      this.$store.commit('issuance_request_own_index/resetForms');
    },
    doChangePage(page) {
      this.setCurrentPage({value: page});
      this.loadPage();
    },
    doSort(column) {
      this.setSortColumn({column: column});
      this.loadPage();
    },
    toDetail(id) {
      this.$router.push({name: "IssuanceRequestOwnViewer", params: {id: id}});
    }
  }
}
</script>
